/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, query: NonNullable<unknown> }} Documents_Search_CountInputs */

const cs_documents_search_count = /** @type {(inputs: Documents_Search_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} výsledků pro „${i?.query}“`)
};

const en_documents_search_count = /** @type {(inputs: Documents_Search_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} results for “${i?.query}”`)
};

/**
* | output |
* | --- |
* | "{count} results for “{query}”" |
*
* @param {Documents_Search_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_search_count = /** @type {((inputs: Documents_Search_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Search_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_search_count(inputs)
	return cs_documents_search_count(inputs)
});